import {hostByBrandByEnv} from '../../../../../hosts'
import {CSP} from '../../../../constants'
import type {Preset} from '../../../../types'

export const RUM = {
  [CSP.CONNECT]: [hostByBrandByEnv.yango.production.rum],
} as const satisfies Preset
